// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adyen-checkout__payment-method {
    margin-bottom: 20px !important;
    margin-top: 0 !important;
    border-radius: 5px !important;
}

.adyen-checkout__payment-method:not(.adyen-checkout__payment-method--selected) {
    max-height: 100px !important;
}

.adyen-checkout__payment-method--selected {
    background: #F3F0ED !important;
}

.adyen-checkout__payment-method__image__wrapper {
    margin-right: 21px !important;
}

.adyen-checkout__input {
    border-radius: 0 !important;
    height: 57px !important;
}

.adyen-checkout__payment-method__header {
    padding: 26px 16px 26px 58px !important
}

.adyen-checkout__payment-method__radio {
    width: 27px !important;
    height: 27px !important;
}

.adyen-checkout__payment-method__radio--selected {
    background-color: #fff !important;
    border: 1px solid #B3B7BC !important;
}

.adyen-checkout__payment-method__radio--selected::after {
    background-color: #674278 !important;
    width: 17px !important;
    height: 17px !important;
}

.adyen-checkout__payment-method:last-child {
    margin-bottom: 0 !important;
}

[class*="payment-method__image"] {
    width: 62px !important;
    height: 40px !important;
}

.adyen-checkout__payment-method__brands {
    display: none !important;
}

.adyen-checkout__card__brands {
    height: 20px !important;
    gap: 3px !important;
    margin-top: -16px !important;
}

.adyen-checkout__card__brands .adyen-checkout__card__brands__brand-wrapper img {
    width: 30px !important;
    height: 20px !important;
}

.adyen-checkout__card__brands .adyen-checkout__card__brands__brand-wrapper {
    width: 30px !important;
    height: 20px !important;
    margin-right: 0px !important;
}

.adyen-checkout__payment-method__name,
.bolt-checkout__payment-method__name,
.adyen-checkout__payment-method__name--selected {
    font-size: 24px !important;
    font-weight: 500 !important;
    font-family: 'Inter', sans-serif !important;
    color: #000 !important;
}

.adyen-checkout__card-input .adyen-checkout__label__text {
    font-size: 16px !important;
    font-weight: 300 !important;
    font-family: 'Inter', sans-serif !important;
    color: #000 !important;
}

.adyen-checkout__card-input .adyen-checkout__input {
    border: 1px solid #B3B7BC !important;
    background-color: #fff !important;
    border-radius: 3px !important;
}

/* Match checkout form validation while keeping Adyen's accessible error copy in the DOM. */
.adyen-checkout__card-input .adyen-checkout__field--error .adyen-checkout__label__text,
.adyen-checkout__card-input .adyen-checkout__label--focused .adyen-checkout__label__text--error {
    color: #B14848 !important;
}

.adyen-checkout__card-input .adyen-checkout__error-text {
    color: #B14848 !important;
    font-family: 'Inter', sans-serif !important;
    font-size: 16px !important;
    font-weight: 300 !important;
    line-height: 24px !important;
    margin-top: 4px !important;
}

.adyen-checkout__card-input .adyen-checkout-input__inline-validation--invalid {
    display: none !important;
}

.adyen-checkout-form-instruction {
    display: none !important;
}

.adyen-checkout__card-input .adyen-checkout__input--focus,
.adyen-checkout__card-input .adyen-checkout__input:focus-within {
    border-color: #B3B7BC !important;
}

/* Keep the error state visible while an invalid field is focused. */
.adyen-checkout__card-input
    .adyen-checkout__field--error
    .adyen-checkout__input,
.adyen-checkout__card-input
    .adyen-checkout__field--error
    .adyen-checkout__input:hover,
.adyen-checkout__card-input
    .adyen-checkout__field--error
    .adyen-checkout__input:focus-within {
    border-color: #B14848 !important;
    box-shadow: none !important;
}

.adyen-checkout__card__holderName .adyen-checkout__input-wrapper input {
    font-size: 17px !important;
    font-weight: 300 !important;
    font-family: 'Inter', sans-serif !important;
    color: #000 !important;
}

@media (max-width: 768px) {
    .adyen-checkout__payment-method__name,
    .bolt-checkout__payment-method__name,
    .adyen-checkout__payment-method__name--selected {
        font-size: 16px !important;
        font-weight: 400 !important;
    }

    [class*="payment-method__image"] {
        width: 45px !important;
        height: 29px !important;
    }

    .adyen-checkout__payment-method__image__wrapper {
        margin-right: 10px !important;
    }

    .adyen-checkout__payment-method__header {
        padding: 20px 16px 15px 44px !important
    }

    .adyen-checkout__payment-method__radio {
        width: 17px !important;
        height: 17px !important;
    }
    
    .adyen-checkout__payment-method__radio--selected {
        background-color: #fff !important;
        border: 1px solid #B3B7BC !important;
    }
    
    .adyen-checkout__payment-method__radio--selected::after {
        background-color: #674278 !important;
        width: 11px !important;
        height: 11px !important;
    }
}
`, "",{"version":3,"sources":["webpack://./overrides/app/adyen/adyen-overrides.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;;;IAGI,0BAA0B;IAC1B,2BAA2B;IAC3B,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA,2FAA2F;AAC3F;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA,oEAAoE;AACpE;;;;;;;;;IASI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI;;;QAGI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,iCAAiC;QACjC,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;QACpC,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":[".adyen-checkout__payment-method {\n    margin-bottom: 20px !important;\n    margin-top: 0 !important;\n    border-radius: 5px !important;\n}\n\n.adyen-checkout__payment-method:not(.adyen-checkout__payment-method--selected) {\n    max-height: 100px !important;\n}\n\n.adyen-checkout__payment-method--selected {\n    background: #F3F0ED !important;\n}\n\n.adyen-checkout__payment-method__image__wrapper {\n    margin-right: 21px !important;\n}\n\n.adyen-checkout__input {\n    border-radius: 0 !important;\n    height: 57px !important;\n}\n\n.adyen-checkout__payment-method__header {\n    padding: 26px 16px 26px 58px !important\n}\n\n.adyen-checkout__payment-method__radio {\n    width: 27px !important;\n    height: 27px !important;\n}\n\n.adyen-checkout__payment-method__radio--selected {\n    background-color: #fff !important;\n    border: 1px solid #B3B7BC !important;\n}\n\n.adyen-checkout__payment-method__radio--selected::after {\n    background-color: #674278 !important;\n    width: 17px !important;\n    height: 17px !important;\n}\n\n.adyen-checkout__payment-method:last-child {\n    margin-bottom: 0 !important;\n}\n\n[class*=\"payment-method__image\"] {\n    width: 62px !important;\n    height: 40px !important;\n}\n\n.adyen-checkout__payment-method__brands {\n    display: none !important;\n}\n\n.adyen-checkout__card__brands {\n    height: 20px !important;\n    gap: 3px !important;\n    margin-top: -16px !important;\n}\n\n.adyen-checkout__card__brands .adyen-checkout__card__brands__brand-wrapper img {\n    width: 30px !important;\n    height: 20px !important;\n}\n\n.adyen-checkout__card__brands .adyen-checkout__card__brands__brand-wrapper {\n    width: 30px !important;\n    height: 20px !important;\n    margin-right: 0px !important;\n}\n\n.adyen-checkout__payment-method__name,\n.bolt-checkout__payment-method__name,\n.adyen-checkout__payment-method__name--selected {\n    font-size: 24px !important;\n    font-weight: 500 !important;\n    font-family: 'Inter', sans-serif !important;\n    color: #000 !important;\n}\n\n.adyen-checkout__card-input .adyen-checkout__label__text {\n    font-size: 16px !important;\n    font-weight: 300 !important;\n    font-family: 'Inter', sans-serif !important;\n    color: #000 !important;\n}\n\n.adyen-checkout__card-input .adyen-checkout__input {\n    border: 1px solid #B3B7BC !important;\n    background-color: #fff !important;\n    border-radius: 3px !important;\n}\n\n/* Match checkout form validation while keeping Adyen's accessible error copy in the DOM. */\n.adyen-checkout__card-input .adyen-checkout__field--error .adyen-checkout__label__text,\n.adyen-checkout__card-input .adyen-checkout__label--focused .adyen-checkout__label__text--error {\n    color: #B14848 !important;\n}\n\n.adyen-checkout__card-input .adyen-checkout__error-text {\n    color: #B14848 !important;\n    font-family: 'Inter', sans-serif !important;\n    font-size: 16px !important;\n    font-weight: 300 !important;\n    line-height: 24px !important;\n    margin-top: 4px !important;\n}\n\n.adyen-checkout__card-input .adyen-checkout-input__inline-validation--invalid {\n    display: none !important;\n}\n\n.adyen-checkout-form-instruction {\n    display: none !important;\n}\n\n.adyen-checkout__card-input .adyen-checkout__input--focus,\n.adyen-checkout__card-input .adyen-checkout__input:focus-within {\n    border-color: #B3B7BC !important;\n}\n\n/* Keep the error state visible while an invalid field is focused. */\n.adyen-checkout__card-input\n    .adyen-checkout__field--error\n    .adyen-checkout__input,\n.adyen-checkout__card-input\n    .adyen-checkout__field--error\n    .adyen-checkout__input:hover,\n.adyen-checkout__card-input\n    .adyen-checkout__field--error\n    .adyen-checkout__input:focus-within {\n    border-color: #B14848 !important;\n    box-shadow: none !important;\n}\n\n.adyen-checkout__card__holderName .adyen-checkout__input-wrapper input {\n    font-size: 17px !important;\n    font-weight: 300 !important;\n    font-family: 'Inter', sans-serif !important;\n    color: #000 !important;\n}\n\n@media (max-width: 768px) {\n    .adyen-checkout__payment-method__name,\n    .bolt-checkout__payment-method__name,\n    .adyen-checkout__payment-method__name--selected {\n        font-size: 16px !important;\n        font-weight: 400 !important;\n    }\n\n    [class*=\"payment-method__image\"] {\n        width: 45px !important;\n        height: 29px !important;\n    }\n\n    .adyen-checkout__payment-method__image__wrapper {\n        margin-right: 10px !important;\n    }\n\n    .adyen-checkout__payment-method__header {\n        padding: 20px 16px 15px 44px !important\n    }\n\n    .adyen-checkout__payment-method__radio {\n        width: 17px !important;\n        height: 17px !important;\n    }\n    \n    .adyen-checkout__payment-method__radio--selected {\n        background-color: #fff !important;\n        border: 1px solid #B3B7BC !important;\n    }\n    \n    .adyen-checkout__payment-method__radio--selected::after {\n        background-color: #674278 !important;\n        width: 11px !important;\n        height: 11px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
